import { Todo } from '@deliveries-app/models';

export enum TodoActionTypes {
  TODO_REQUEST = 'todos/TODO_REQUEST',
  GET_ALL_TODOS_SUCCESS = 'todos/GET_ALL_TODOS_SUCCESS',
  GET_ALL_TODOS_FAILURE = 'todos/GET_ALL_TODOS_FAILURE',
  CREATE_TODO_SUCCESS = 'todos/CREATE_TODO_SUCCESS',
  CREATE_TODO_FAILURE = 'todos/CREATE_TODO_FAILURE',
  UPDATE_TODO_SUCCESS = 'todos/UPDATE_TODO_SUCCESS',
  UPDATE_TODO_FAILURE = 'todos/UPDATE_TODO_FAILURE',
  DELETE_TODO_SUCCESS = 'todos/DELETE_TODO_SUCCESS',
  DELETE_TODO_FAILURE = 'todos/DELETE_TODO_FAILURE',
}

export type TodoActions =
  | { type: TodoActionTypes.TODO_REQUEST }
  | { type: TodoActionTypes.GET_ALL_TODOS_SUCCESS; payload: Todo[] }
  | { type: TodoActionTypes.GET_ALL_TODOS_FAILURE; payload: string }
  | { type: TodoActionTypes.CREATE_TODO_SUCCESS; payload: Todo }
  | { type: TodoActionTypes.CREATE_TODO_FAILURE; payload: string }
  | {
      type: TodoActionTypes.UPDATE_TODO_SUCCESS;
      payload: { id: number; completed: boolean };
    }
  | {
      type: TodoActionTypes.UPDATE_TODO_FAILURE;
      payload: string;
    }
  | { type: TodoActionTypes.DELETE_TODO_SUCCESS; payload: number }
  | { type: TodoActionTypes.DELETE_TODO_FAILURE; payload: string };
